import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../components/Loader";
import { createResourceUser, resourceUserDetail, updateResourceUser, showToast } from "../Utils/utils";

const EditUser = () => {
    const navigate = useNavigate()
    const { resourceId, userId } = useParams();
    const [loading, setLoading] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState(null);
    const [website, setWebsite] = useState("");
    const [description, setDescription] = useState("");
    const [imageUrl, setImageUrl] = useState(null);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        fetchDetails();
    }, [userId]);

    const fetchDetails = async () => {
        try {
            setLoading(true);

            const res = await resourceUserDetail(userId);

            if (res?.status == 200) {
                setName(res.data.name);
                setEmail(res.data.email);
                setDescription(res.data.description);
                setWebsite(res.data.website);
                setImageUrl(res.data.image_url);
            } else {
                showToast("User not found");
                navigate(`/manage-resource/${resourceId}`);
            }

        } catch (error) {
            console.error(error);
            showToast("Failed to load user");
            navigate(`/manage-resource/${resourceId}`);
        } finally {
            setLoading(false);
        }
    };

    const onIconUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImageUrl(file)
    };

    const isFormValid =
        name.trim() &&
        website.trim() &&
        description.trim();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("resource_id", resourceId);
            formData.append("resource_user_id", userId);
            formData.append("name", name);
            formData.append("email", email);
            formData.append("description", description);
            formData.append("website", website);
            formData.append("file", imageUrl);

            const response = await updateResourceUser({ formData });
            if (response.status == 200) {
                showToast("Agent updated successfully", "success")
                setTimeout(() => {
                    window.location.href = `/manage-resource/${resourceId}`;
                }, [1000])
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.log(error, "error...");
            setLoading(false)
            showToast(error.message, "error")
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to={`/manage-resource/${resourceId}`}><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Edit Agent</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <form className="card mb-4" onSubmit={(e) => handleSubmit(e)}>
                                            <div className="card-body">

                                                <div className="form-group">
                                                    <label>Name</label>
                                                    <input
                                                        className="form-control"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Email</label>
                                                    <input
                                                        className="form-control"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label>Description</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={4}
                                                        value={description}
                                                        onChange={(e) => setDescription(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Website</label>
                                                    <input
                                                        className="form-control"
                                                        value={website}
                                                        onChange={(e) => setWebsite(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group mt-3">
                                                    <label>Image</label>
                                                    <div className="d-flex gap-4">
                                                        <label className="btn btn-outline-primary mb-0" style={{ height: "36px" }}>
                                                            Select File
                                                            <input hidden type="file" accept="image/*" onChange={onIconUpload} />
                                                        </label>
                                                        {imageUrl && (
                                                            <>
                                                                <div className="mt-2">
                                                                    {imageUrl instanceof File ? (
                                                                        <span>{imageUrl.name}</span>
                                                                    ) : imageUrl ? (
                                                                        <img
                                                                            src={imageUrl}
                                                                            alt="icon"
                                                                            style={{ width: 80, height: 80, objectFit: "cover" }}
                                                                        />
                                                                    ) : null}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>

                                                <button type="submit" className="btn cta-btn mt-4" disabled={loading || !isFormValid}>
                                                    Update
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default EditUser;
